import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'
import { userProfileKeys } from '@/composable/queries/keys'
import ReadNotifications from '@/api/Dara/ReadNotifications'
import UserProfile from '@/api/Dara/UserProfile'

interface MarkAsReadData {
  notificationId: string;
}

export const useNotificationsQuery = (
  userProfileId: Ref<number>,
  enabled: Ref<boolean>,
  page: Ref<number> = ref(1),
) =>
  useQuery({
    queryKey: userProfileKeys.notificationsPage(userProfileId, page),
    queryFn: () => UserProfile.notifications(userProfileId.value, page.value),
    enabled,
  })

export const useUnreadNotificationsQuery = (
  userProfileId: Ref<number>,
  enabled: Ref<boolean>,
) =>
  useQuery({
    queryKey: userProfileKeys.unreadNotifications(userProfileId),
    queryFn: () => UserProfile.unreadNotifications(userProfileId.value),
    enabled,
  })

export const useReadNotification = (userProfileId: Ref<number>) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (markAsReadData: MarkAsReadData) => ReadNotifications.readNotification(markAsReadData.notificationId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: userProfileKeys.notifications(userProfileId),
      })
    },
  })
}
